import "./Home.css";
import { FaPhone, FaUsers, FaMapMarkerAlt, FaCopyright, FaMale, FaFemale } from "react-icons/fa";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../App";
import basavannaImg from "./images/basavanna.jpeg";
import coupleIcon from "./images/couple.png"; // Add your boy+girl image here
import groomIcon from "./images/groom.png"; // Add your groom image here
import brideIcon from "./images/bride.png"; // Add your bride image here
import explore from "./images/explore.png";
import leader1 from "./images/leader1.jpeg";
import leader2 from "./images/leader2.jpeg";
import leader3 from "./images/leader3.jpeg";
import leader4 from "./images/leader4.jpeg";
import leader5 from "./images/leader5.jpeg";
import leader6 from "./images/leader6.jpeg";
import leader7 from "./images/leader7.jpeg";

function Home() {
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [groomCount, setGroomCount] = useState(0);
  const [brideCount, setBrideCount] = useState(0);
  const [displayTotal, setDisplayTotal] = useState(0);
  const [displayGroom, setDisplayGroom] = useState(0);
  const [displayBride, setDisplayBride] = useState(0);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    animateCount(totalCount, setDisplayTotal);
  }, [totalCount]);

  useEffect(() => {
    animateCount(groomCount, setDisplayGroom);
  }, [groomCount]);

  useEffect(() => {
    animateCount(brideCount, setDisplayBride);
  }, [brideCount]);

  const animateCount = (target, setter) => {
    const duration = 4000;
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setter(target);
        clearInterval(timer);
      } else {
        setter(Math.floor(current));
      }
    }, duration / steps);
  };

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${baseUrl}/users`);
      const sortedUsers = res.data.sort((a, b) => b.id - a.id);
      setUsers(sortedUsers);
      
      setTotalCount(sortedUsers.length);
      setGroomCount(sortedUsers.filter(user => user.gender === "Male").length);
      setBrideCount(sortedUsers.filter(user => user.gender === "Female").length);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const leaders = [
    { img: leader3, name: "ಶ್ರೀ ಶಿವಕುಮಾರ್ ಬಿ.ಆರ್", role: "ಅಧ್ಯಕ್ಷರು" },
    { img: leader1, name: "ಶ್ರೀ ಬಸವರಾಜು ಆಲೂರು", role: "ಗೌರವಾಧ್ಯಕ್ಷರು" },
    { img: leader5, name: "ಶ್ರೀ ಹು.ವ. ಮಹಾದೇವ ಪ್ರಸಾದ್", role: "ಪ್ರಧಾನ ಕಾರ್ಯದರ್ಶಿ" },
    { img: leader4, name: "ಶ್ರೀ ಬಾಗಳಿ ಮಹೇಶ್", role: "ಖಜಾಂಚಿ" },
    { img: leader2, name: "ಶ್ರೀ ರಾಜಶೇಖರ್", role: "ರಾಜ್ಯ ಸಂಚಾಲಕರು" },
    { img: leader6, name: "ಶ್ರೀ ಪಿ ಪ್ರಭುಸ್ವಾಮಿ",  },
    { img: leader7, name: "ಲೋಹಿತೇಶ ವೈ ಇ",  },
  ];

  return (
    <div className="home-container">
      <div className="right-side">
          {/* Animated Particles */}
          <div className="particles">
            {[...Array(20)].map((_, i) => (
              <div key={i} className="particle"></div>
            ))}
          </div>

          <div className="content">
            {/* Main Title Section */}
            <div className="title-section">
              <h1 className="main-title">
                <span className="title-line">ಕರ್ನಾಟಕ ರಾಜ್ಯ ವೀರಶೈವ ಲಿಂಗಾಯತ</span>
                <span className="title-line highlight">ನೌಕರರ ಕ್ಷೇಮಾಭಿವೃದ್ಧಿ ಸಂಘ (ರಿ.)</span>
              </h1>
              <div className="subtitle-container">
                <div className="subtitle-decoration"></div>
                <div className="subtitle">ಜಿಲ್ಲಾ ಘಟಕ, ಮೈಸೂರು</div>
                <div className="subtitle-decoration"></div>
              </div>
            </div>

             {/* Background Image */}
            <div className="center-image-section">
              <div 
                className="center-background-image" 
                style={{ backgroundImage: `url(${basavannaImg})` }}
              >
                <div className="image-overlay"></div>
              </div>
            </div>

            {/* Stats Cards - Horizontal */}
            <div className="stats-container">
              <div className="stat-card">
                <div className="stat-icon-circle">
                  <img src={coupleIcon} alt="couple" className="stat-icon-image" />
                </div>
                <div className="stat-content">
                  <div className="stat-number">{displayTotal}</div>
                  <div className="stat-label">Profiles </div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon-circle">
                  <img src={groomIcon} alt="groom" className="stat-icon-image" />
                </div>
                <div className="stat-content">
                  <div className="stat-number">{displayGroom}</div>
                  <div className="stat-label">Grooms</div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon-circle">
                  <img src={brideIcon} alt="bride" className="stat-icon-image" />
                </div>
                <div className="stat-content">
                  <div className="stat-number">{displayBride}</div>
                  <div className="stat-label">Brides</div>
                </div>
              </div>
            </div>

            {/* CTA Button */}
         

<div className="stat-card m-4">
                <div className="stat-icon-circle">
                  <img src={explore} alt="bride" className="stat-icon-image" />
                </div>
                <div className="stat-content">
                  <a href="/login" className="launch-btn primary">
              
                <span> Explore  Platform</span>
              </a>
                </div>
              </div>
           

            <h1 className="main-title">
              <span className="title-line">ಸತ್ಯ, ಭಕ್ತಿ ಮತ್ತು ನಂಬಿಕೆಯೇ ಒಳ್ಳೆಯ ದಾಂಪತ್ಯ ಜೀವನದ ಆಧಾರ.</span>
            </h1>



            {/* Moving Leaders Carousel */}
            <div className="slider-container">
              <h2 className="section-title">ನಮ್ಮ ನಾಯಕರು</h2>
              <div className="slider">
                <div className="track">
                  {leaders.map((leader, index) => (
                    <div key={index} className="leader">
                      <div className="leader-image-wrapper">
                        <img src={leader.img} alt={leader.name} />
                        <div className="leader-role-badge">{leader.role}</div>
                      </div>
                      <span className="leader-name">{leader.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Leadership Details Grid */}
            <div className="details-section">
              <h2 className="section-title">ಸಂಘದ ಪದಾಧಿಕಾರಿಗಳು</h2>
              <div className="details">
                <div className="detail-card">
                  <img src={leader3} alt="ಅಧ್ಯಕ್ಷರು" className="card-icon" />
                  <div className="detail-role">ಅಧ್ಯಕ್ಷರು</div>
                  <div className="detail-name">ಶ್ರೀ ಶಿವಕುಮಾರ್ ಬಿ. ಆರ್</div>
                  <div className="detail-phone">
                    <FaPhone className="phone-icon" /> 
                    <a href="tel:9945534640">9945534640</a>
                  </div>
                </div>

                <div className="detail-card">
                  <div className="card-icon">🌟</div>
                  <div className="detail-role">ರಾಜ್ಯಾಧ್ಯಕ್ಷರು</div>
                  <div className="detail-name">ಶ್ರೀ ಸೋಮಶೇಖರಯ್ಯ</div>
                  <div className="detail-phone">
                    <FaPhone className="phone-icon" /> 
                    <a href="tel:9845854404">9845854404</a>
                  </div>
                </div>

                <div className="detail-card">
                  <div className="card-icon">⭐</div>
                  <div className="detail-role">ಗೌರವಾಧ್ಯಕ್ಷರು</div>
                  <div className="detail-name">ಶ್ರೀ ಬಸವರಾಜು ಆಲೂರು</div>
                  <div className="detail-phone">
                    <FaPhone className="phone-icon" /> 
                    <a href="tel:8310790505">8310790505</a>
                  </div>
                </div>

                <div className="detail-card">
                  <div className="card-icon">📋</div>
                  <div className="detail-role">ಪ್ರಧಾನ ಕಾರ್ಯದರ್ಶಿ</div>
                  <div className="detail-name">ಶ್ರೀ ಹು.ವ. ಮಹಾದೇವ ಪ್ರಸಾದ್</div>
                  <div className="detail-phone">
                    <FaPhone className="phone-icon" /> 
                    <a href="tel:9481218684">9481218684</a>
                  </div>
                </div>

                <div className="detail-card">
                  <div className="card-icon">💰</div>
                  <div className="detail-role">ಖಜಾಂಚಿ</div>
                  <div className="detail-name">ಶ್ರೀ ಬಾಗಳಿ ಮಹೇಶ್</div>
                  <div className="detail-phone">
                    <FaPhone className="phone-icon" /> 
                    <a href="tel:9980989368">9980989368</a>
                  </div>
                </div>

                <div className="detail-card">
                  <div className="card-icon">📞</div>
                  <div className="detail-role">ರಾಜ್ಯ ಸಂಚಾಲಕರು</div>
                  <div className="detail-name">ಶ್ರೀ ರಾಜಶೇಖರ್</div>
                  <div className="detail-phone">
                    <FaPhone className="phone-icon" /> 
                    <a href="tel:9141553637">9141553637</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer with Development Credit */}
            <footer className="home-footer">
              <div className="footer-content">
                <p className="org-name">© 2026 ಕರ್ನಾಟಕ ರಾಜ್ಯ ವೀರಶೈವ ಲಿಂಗಾಯತ ನೌಕರರ ಕ್ಷೇಮಾಭಿವೃದ್ಧಿ ಸಂಘ (ರಿ.)</p>
                <p className="org-name">ಜಿಲ್ಲಾ ಘಟಕ, ಮೈಸೂರು</p>
                <p className="copyright">ಎಲ್ಲ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ</p>
                <div className="developer-credit">
                  <FaCopyright className="copyright-icon" />
                  <span>Developed by @2026 </span>
                  <a href="https://cptorus.in" target="_blank" rel="noopener noreferrer" className="company-link">
                    Torus Solutions Mysore
                  </a>
                </div>
              </div>
            </footer>
          </div>
        </div>
    </div>
  );
}

export default Home;